import { h } from 'preact';

export function RequestQuote({ product, requestQuoteHandler }) {
  return (
    <div class="purchase-block__request-quote-message">
      <div class="purchase-block__request-quote">
        <a
          class="button enabled"
          tabIndex={-1}
          onClick={requestQuoteHandler}
        >
          {product.request_quote_label}
          {product.user && (
            <svg class="icon js-icon-exists" aria-hidden="true" role="img">
              <use
                xlinkHref={`/themes/custom/particle/dist/app-drupal/assets/images/sprite.svg#sprite-white-quote`}
              ></use>
            </svg>
          )}
        </a>
      </div>
    </div>
  );
}
